/**
 * AdminInstallBillingRpcClient - AtomRpc integration for admin install
 * billing endpoints (`admin/installs/billing/*`).
 *
 * Drives the install-fee + managed-subscription state machines (setPricing,
 * compInstall, sendInstallInvoice, etc.). Requires admin authentication
 * via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { InstallBillingRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminInstallBillingRpcClient extends AtomRpc.Tag<AdminInstallBillingRpcClient>()(
  "AdminInstallBillingRpcClient",
  {
    group: InstallBillingRpcs,
    protocol: makeRpcClientLayer(InstallBillingRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
